import BlockRenderer from '../../cms/BlockRenderer'
import { useCart } from '../../cart'
import type { CmsPage } from '../../cms/types'
import type { RuntimeHomeSettings } from '../hooks/runtime/cmsApi'
import type { Slide } from '../types'
import HomeFallbackFooter from './HomeFallbackFooter'
import HomeFallbackHero from './HomeFallbackHero'
import { HomeFallbackHeader } from './home-fallback/HomeFallbackHeader'

type Props = {
  homePageData: CmsPage | null
  homeSettings: RuntimeHomeSettings
  isAdmin: boolean
  slides: Slide[]
  currentSlide: Slide | undefined
  currentIndex: number
  onPrev: () => void
  onNext: () => void
  onSelectSlide: (index: number) => void
  shouldRenderRuntimeFooter: boolean
}

const RuntimeHomeBlocksView = ({
  homePageData,
  homeSettings,
  isAdmin,
  slides,
  currentSlide,
  currentIndex,
  onPrev,
  onNext,
  onSelectSlide,
  shouldRenderRuntimeFooter,
}: Props) => {
  const { itemCount } = useCart()

  return (
    <div
      className="shop-runtime-stage min-h-screen"
      style={{
        backgroundColor: 'var(--theme-color-background, #f8fafc)',
        color: 'var(--theme-color-text, #0f172a)',
      }}
    >
      <div className="shop-runtime-grid" />
      <div className="shop-layout">
        <HomeFallbackHeader
          homeSettings={homeSettings}
          isAdmin={isAdmin}
          itemCount={itemCount}
        />

        <HomeFallbackHero
          currentSlide={currentSlide}
          currentIndex={currentIndex}
          slides={slides}
          onPrev={onPrev}
          onNext={onNext}
          onSelectSlide={onSelectSlide}
        />

        {homePageData ? (
          <section aria-label={homePageData.title || 'Homepage content'}>
            <BlockRenderer layout={homePageData.content} className="space-y-0" />
          </section>
        ) : null}

        {shouldRenderRuntimeFooter ? (
          <div className="pt-8">
            <HomeFallbackFooter homeSettings={homeSettings} />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default RuntimeHomeBlocksView
